import { i18n } from "@/i18n";

export default {
  path: "/user/form/first-login",
  name: "userActivateRoute",
  component: () => import(/* webpackChunkName: "user" */ "@/views/User/UserActivateView.vue"),
  meta: {
    authRequired: false,
    title: i18n.global.t("dashboard.welcome_to_studea"),
    breadcrumb: false,
  },
};
